import{ Container,Nav,Navbar,NavDropdown} from 'react-bootstrap';
import './Navbar.css';
import logo from '../images/logo.png';
import {Link} from 'react-router-dom'
function NavigationBar() {
  return (
    <Navbar expand="lg" >
      <Container>
        <Navbar.Brand href="#home" className="logo">
          <img src={logo} alt="logo" width="120" height="50" className="d-inline-block align-top" />{' '}
          <h2> D-Clinic</h2>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">

            <Link  to="/home">Home</Link>
            <NavDropdown title="Pages" id="basic-nav-dropdown">
                <NavDropdown.Item ><Link to={'/about'}>About Us</Link> </NavDropdown.Item>
                <NavDropdown.Item ><Link to={'/blog'}>Our Team</Link> </NavDropdown.Item>
                <NavDropdown.Item ><Link to={'/booking'}>Booking</Link> </NavDropdown.Item>
                <NavDropdown.Item ><Link to={'/error'}>Error 404</Link> </NavDropdown.Item>
                <NavDropdown.Item ><Link to={'/signup'}>Sign Up</Link> </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Services" id="basic-nav-dropdown">
                <NavDropdown.Item><Link to={'/service'}>Service</Link></NavDropdown.Item>
                <NavDropdown.Item><Link to={'/service'}>Service Details</Link></NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Blog" id="basic-nav-dropdown">
                <NavDropdown.Item><Link to={'/blog'}>Blog</Link> </NavDropdown.Item>
                <NavDropdown.Item><Link to={'/blog'}>Blog Details</Link> </NavDropdown.Item>
            </NavDropdown>
            <Link to="/contact">Contact Us</Link>
            <Link to="#"><i className="fa-solid fa-magnifying-glass"></i></Link>
            <Link to="/contact"><i className="fa-solid fa-phone"></i>{' '}(+20) 1016407214</Link>
            <Link to="/login">
                <button className='btn'>Sign Up<span><i className="fa-solid fa-chevron-right"></i></span></button>
            </Link>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;